/** @format */

export type initUserSessionDataType = {
  email: string;
  entry_id: number;
  user_id: number;
  agent_master_id: number;
  ip_flag: boolean;
  redirect_auth_flag: boolean;
  ip_code: number;
};

export const initUserSessionData: initUserSessionDataType = {
  email: "",
  entry_id: 0,
  user_id: 0,
  agent_master_id: 0,
  ip_flag: false,
  redirect_auth_flag: false,
  ip_code: 0,
};
